import TheMainLogo from '@/components/Platform/TheMainLogo';

export default {
  name: 'TheFooter',

  components: {
    TheMainLogo,
  },

  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
    activeRouteName() {
      return this.$route.name;
    },
  },
};
